import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button as RKButton } from 'reakit/Button';
import styles from './Button.module.less';
import { getButtonClassNames, getInlineStylesWithContrast } from '../helpers';
const Button = forwardRef(
// forward ref is necessary for the way Modal.tsx renders the open modal button
(props, ref) => {
    const { disabled = false, focusable = true, id, icon = null, onClick, style = {}, text = '', type = 'button', className: customClassName = '' } = props;
    // error handling
    let errorStyles = {};
    let whitespaceText = '';
    // Submits don't need an onClick
    if (onClick == null && type !== 'submit') {
        errorStyles = { border: '2px solid red' };
        console.error(`onClick must be supplied to Button - buttons must have actions associated with them. If using as a submit, set type to 'submit'`);
    }
    if (!text) {
        errorStyles = { border: '2px solid red' };
        whitespaceText = '\u00A0'; // &nbsp;
        console.error('text must be supplied to Button - this is required to make an accessible name');
    }
    const className = getButtonClassNames(props);
    const finalStyles = Object.assign({}, getInlineStylesWithContrast(style), errorStyles);
    const finalText = text ? text : whitespaceText;
    const finalContent = icon ? (_jsx("span", { className: styles['button-with-icon'], children: _jsxs(_Fragment, { children: [finalText, icon] }) })) : (finalText);
    // The only props we want to pass directly (e.g. wide open) to the Reakit Button
    // are for a11y purposes; these often come from other reakit components like modals.
    const ariaProps = {};
    for (const [propKey, propValue] of Object.entries(props)) {
        if (propKey.startsWith('aria') || propKey.startsWith('on')) {
            ariaProps[propKey] = propValue;
        }
    }
    return (_jsx(RKButton, { ...ariaProps, className: `${className} ${customClassName}`.trim(), disabled: disabled, focusable: focusable, id: id, onClick: onClick, ref: ref, style: finalStyles, type: type, children: finalContent }));
});
export default Button;
